import React from 'react';
import { Tag, ArrowRight, Zap } from 'lucide-react';
export function WinterCombosBanner() {
  const scrollToOffers = (e: React.MouseEvent) => {
    e.preventDefault();
    const section = document.getElementById('ofertas');
    if (section) {
      section.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section className="relative bg-gradient-to-br from-[#1a0606] via-[#2a0a08] to-[#1a0606] py-12 md:py-16 px-5 overflow-hidden border-y-[3px] border-[#ff3b30] shadow-[0_0_60px_rgba(255,59,48,0.15)_inset]" data-id="element-489" data-mp="3fshqc4nbo8gi">
      {/* Decorative tags */}
      <Tag className="absolute top-6 left-[10%] w-6 h-6 text-[#ff3b30]/20 hidden md:block animate-pulse" data-id="element-490" data-mp="cctzj0fpa9ew" />
      <Tag className="absolute bottom-8 right-[15%] w-8 h-8 text-[#ff3b30]/15 hidden md:block animate-pulse" style={{
      animationDelay: '1s'
    }} data-id="element-491" data-mp="2ko5zm9svjxl" />

      {/* Radial glow effect */}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(255,59,48,0.22)_0%,transparent_60%)] pointer-events-none" data-id="element-492" data-mp="v8sdmdbxm72x" />

      {/* Accent stripes */}
      <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-[#ff3b30] to-transparent" data-id="element-493" data-mp="ijh53qtcbwkt" />
      <div className="absolute bottom-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-[#ff3b30] to-transparent" data-id="element-494" data-mp="4slrk17wcraw" />

      <div className="max-w-[1100px] mx-auto relative z-10" data-id="element-495" data-mp="8sm8ptmdrgln">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 items-center" data-id="element-496" data-mp="3qzk0oy76huss">
          {/* Image */}
          <div className="relative order-2 md:order-1" data-id="element-497" data-mp="3vywobl5vj5wf">
            <div className="relative rounded-2xl overflow-hidden border-2 border-[#ff3b30]/50 shadow-[0_10px_40px_rgba(255,59,48,0.25)] aspect-[4/3] md:aspect-[5/4]" data-id="element-498" data-mp="3vwaf7h3c4ic3">
              <img src="https://images.unsplash.com/photo-1517836357463-d25dfeac3438?w=800&q=80" alt="Ofertas imperdibles AlphaFit" className="w-full h-full object-cover" data-id="element-499" data-mp="3m0z02xo0l93t" />
              <div className="absolute inset-0 bg-gradient-to-br from-[#ff3b30]/30 via-transparent to-black/40" data-id="element-500" data-mp="1k6q7re7truxk" />
              <div className="absolute top-4 left-4 bg-[#ff3b30] text-white px-4 py-2 rounded-full font-black text-xs md:text-sm uppercase tracking-wider shadow-lg flex items-center gap-1.5" data-id="element-501" data-mp="2o6o8jq1yc9hc">
                <Zap className="w-4 h-4" data-id="element-502" data-mp="2k6xl9wbmwbhk" />
                Hasta -35% OFF
              </div>
            </div>
          </div>

          {/* Content */}
          <div className="order-1 md:order-2 text-center md:text-left" data-id="element-503" data-mp="3bv7kcfk7n4e6">
            <div className="inline-flex items-center gap-2 bg-[#ff3b30]/10 border border-[#ff3b30]/40 text-[#ff3b30] px-4 py-1.5 rounded-full text-xs md:text-sm font-bold uppercase tracking-[2px] mb-4" data-id="element-504" data-mp="37u5h7nn6a86x">
              <Tag className="w-4 h-4" data-id="element-505" data-mp="2y5dq1hpxrrx2" />
              Ofertas Imperdibles
            </div>

            <h2 className="text-3xl md:text-4xl lg:text-5xl font-black text-white uppercase leading-tight tracking-tight mb-4" data-id="element-506" data-mp="3vkrp9ex6fsgx">
              Precios que no vas a{' '}
              <span className="text-[#ff3b30]" data-id="element-507" data-mp="3qrosyz10m4x1">volver a ver</span>
            </h2>

            <p className="text-[#ccc] text-base md:text-lg leading-relaxed mb-6 max-w-xl mx-auto md:mx-0" data-id="element-508" data-mp="214ks4iewb09">
              Seleccionamos los{' '}
              <strong className="text-white" data-id="element-509" data-mp="bwy7uhtrbmwa">
                mejores combos y suplementos
              </strong>{' '}
              con descuentos reales por tiempo limitado. Llevate más por menos —
              pero apurate, el stock vuela.
            </p>

            <div className="flex flex-col sm:flex-row items-center gap-3 mb-6 justify-center md:justify-start" data-id="element-510" data-mp="kw1s3p4nu8cd">
              <div className="flex items-center gap-2 text-sm text-[#aaa]" data-id="element-511" data-mp="puw8kkf5nktb">
                <span className="w-2 h-2 bg-[#ff3b30] rounded-full animate-pulse" data-id="element-512" data-mp="uoqyi5lcsw0u"></span>
                <span className="font-semibold" data-id="element-513" data-mp="zmisd55k6s7o">Stock limitado</span>
              </div>
              <span className="hidden sm:inline text-[#555]" data-id="element-514" data-mp="13pykbo6oo4e1">·</span>
              <div className="text-sm text-[#aaa] font-semibold" data-id="element-515" data-mp="18n77k36ouym5">
                Ahorrá hasta{' '}
                <span className="text-[#ff3b30] font-black" data-id="element-516" data-mp="v0htm5koi6qb">$1.640</span>
              </div>
            </div>

            <a href="#ofertas" onClick={scrollToOffers} className="group inline-flex items-center gap-3 bg-[#ff3b30] hover:bg-[#e0271d] text-white font-black uppercase tracking-wider text-sm md:text-base py-4 px-7 md:px-9 rounded-lg shadow-[0_8px_25px_rgba(255,59,48,0.4)] hover:shadow-[0_10px_35px_rgba(255,59,48,0.6)] transition-all duration-300 hover:-translate-y-1" data-id="element-517" data-mp="r07pyzkczsem">
              Ver Ofertas Imperdibles
              <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-518" data-mp="m0bl6y3u7wy0" />
            </a>
          </div>
        </div>
      </div>
    </section>;
}